import { fetchJsonByGet, fetchJsonByPost } from './execute';
import fromOptions from '../converters/optionsConverter';
import { getParams, getProjectZoneId } from '../reducers/analyticsApp';
import handleResponse from './common';
import fromActualizationResponse from '../converters/projectApiConverter';

export const fetchOptions = (dispatch, getState) =>
  fetchJsonByGet('/options', getParams(getState())).then((response) => ({
    options: fromOptions(response),
  }));

export const checkActualization = () => (dispatch, getState) =>
  fetchJsonByGet(
    `/actualization/endpoint?timezone=${getProjectZoneId(getState())}`,
    getParams(getState())
  )
    .then(fromActualizationResponse)
    .catch(() => {});

export const updateOptions = (options) => (dispatch, getState) =>
  fetchJsonByPost('/users/options', options, getParams(getState())).then((response) => ({
    userZoneId: response.timezone,
  }));

export const fetchConfig = () =>
  fetch('/config.json')
    .then(handleResponse)
    .then((response) => response.json());
